import { capitalCategoricalPalette } from "../../capitalCategoricalPalette.js";
const MuiRadarChart = {
  defaultProps: {
    colors: capitalCategoricalPalette,
    enableKeyboardNavigation: true
  }
};
export {
  MuiRadarChart
};
//# sourceMappingURL=MuiRadarChart.js.map
